import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { BrandSocialMediaCode } from '../../enums/brand-social-media-code';

@jsonObject
export class BrandSocialMediaCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: BrandSocialMediaCode;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(Date)
  public readonly createdAt!: string;
}
